"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateValidator = exports.DATE_PATTERN_FROM_UI = void 0;
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
require("moment-jdateformatparser");
require("moment-business-days");
var moment_1 = __importDefault(require("moment"));
var memoize_one_1 = __importDefault(require("memoize-one"));
var date_fns_1 = require("date-fns");
var publicInterface_1 = require("./publicInterface");
exports.DATE_PATTERN_FROM_UI = 'YYYY-MM-DD';
/** ******************************************************************************** */
// DON'T CLEAN THE UNUSED METHODS IN THIS FILE BECAUSE THEY ARE USED IN EXPRESSIONS!!!
/** ******************************************************************************** */
var DateValidator = /** @class */ (function () {
    function DateValidator(dateFormat) {
        var _this = this;
        this.getDate = function (date, format) {
            if (typeof format === 'string' && format.toLowerCase() === 'mm/dd/yyyy') {
                var mdy = date.split('/');
                if (mdy[2] && mdy[0] && mdy[1]) {
                    return "".concat(mdy[2], "-").concat(mdy[0], "-").concat(mdy[1]);
                }
            }
            else if (typeof format === 'string' && format.toLowerCase() === 'yyyy-mm-dd') {
                var mdy = date.split('-');
                if (mdy[2] && mdy[0] && mdy[1]) {
                    return "".concat(mdy[1], "/").concat(mdy[2], "/").concat(mdy[0]);
                }
            }
            return date;
        };
        this.translateDateFormat = (0, memoize_one_1.default)(function (dateFormat) {
            return (0, moment_1.default)().toMomentFormatString(dateFormat || 'MM/dd/yyyy');
        });
        this.getDateString = function (date) { return _this.getDate(date, _this.DEFAULT_DATE_PATTERN); };
        this.parseDateStr = function (dateStr, pattern) {
            if (pattern === void 0) { pattern = exports.DATE_PATTERN_FROM_UI; }
            return (0, moment_1.default)(dateStr, pattern.toUpperCase());
        };
        this.formatDate = function (dateStr, pattern) { return (0, moment_1.default)(dateStr).format(pattern); };
        this.getLocalDateFromObject = function (i) { return i; };
        this.compareDateStr = function (dateOneStr, dateTwoStr, pattern, operator, includeNonBusiness) {
            if (!(dateOneStr && dateTwoStr)) {
                return true;
            }
            if (pattern) {
                var dateOne = _this.parseDateStr(dateOneStr, pattern);
                var dateTwo = _this.parseDateStr(dateTwoStr, pattern);
                if (!(dateOne && dateTwo)) {
                    return true;
                }
                if (!operator) {
                    return dateOne.isSame(dateTwo);
                }
                switch (operator) {
                    case '>':
                        return dateOne.isAfter(dateTwo);
                    case '>=':
                        return dateOne.isAfter(dateTwo) || dateOne.isSame(dateTwo);
                    case '==':
                        return dateOne.isSame(dateTwo);
                    case '<':
                        return dateOne.isBefore(dateTwo);
                    case '<=':
                        return dateOne.isBefore(dateTwo) || dateOne.isSame(dateTwo);
                    case '|':
                        return includeNonBusiness ? dateOne.diff(dateTwo, 'days') : dateOne.businessDiff(dateTwo);
                    default:
                        return dateOne.isSame(dateTwo);
                }
            }
            return _this.compareDateStr(dateOneStr, dateTwoStr, exports.DATE_PATTERN_FROM_UI, operator);
        };
        this.modifyDateStr = function (dateOneStr, amount, unit, pattern, operator, includeNonBusiness) {
            if (!dateOneStr) {
                return true;
            }
            if (pattern) {
                var upperCasePattern = pattern.toUpperCase();
                var dateOne = (0, moment_1.default)(dateOneStr, upperCasePattern);
                switch (operator) {
                    case '+':
                        return includeNonBusiness
                            ? dateOne.add(amount, unit).format(pattern)
                            : dateOne.businessAdd(amount, unit).format(pattern);
                    case '-':
                        return includeNonBusiness
                            ? dateOne.subtract(amount, unit).format(pattern)
                            : dateOne.businessSubtract(amount, unit).format(pattern);
                    default:
                        return dateOne;
                }
            }
            return _this.modifyDateStr(dateOneStr, amount, unit, exports.DATE_PATTERN_FROM_UI, operator);
        };
        // old - bad behavior on nulls, and returns negative answers (dateOne and dateTwo are swapped)
        // daysBetween = (dateOne, dateTwo, includeNonBusiness = true) =>
        //     this.compareDateStr(dateOne, dateTwo, DATE_PATTERN_FROM_UI, '|', includeNonBusiness);
        this.daysBetween = publicInterface_1.daysBetween;
        this.addDaysToDateStr = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.modifyDateStr(dateOne, amount, 'day', exports.DATE_PATTERN_FROM_UI, '+', includeNonBusiness);
        };
        this.subtractDaysToDateStr = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.modifyDateStr(dateOne, amount, 'day', exports.DATE_PATTERN_FROM_UI, '-', includeNonBusiness);
        };
        this.addYearsToDateStr = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.modifyDateStr(dateOne, amount, 'year', exports.DATE_PATTERN_FROM_UI, '+', includeNonBusiness);
        };
        this.addMonthsToDateStr = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.modifyDateStr(dateOne, amount, 'month', exports.DATE_PATTERN_FROM_UI, '+', includeNonBusiness);
        };
        this.addDaysToDate = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.addDaysToDateStr(dateOne, amount, includeNonBusiness);
        };
        this.subtractDaysToDate = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.subtractDaysToDateStr(dateOne, amount, includeNonBusiness);
        };
        this.addYearsToDate = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.addYearsToDateStr(dateOne, amount, includeNonBusiness);
        };
        this.addMonthsToDate = function (dateOne, amount, includeNonBusiness) {
            if (includeNonBusiness === void 0) { includeNonBusiness = true; }
            return _this.addMonthsToDateStr(dateOne, amount, includeNonBusiness);
        };
        this.today = function () { return _this.todayStr(exports.DATE_PATTERN_FROM_UI); };
        this.todayDate = function () { return _this.today(); };
        this.compareLocalDate = function (dateOneStr, dateTwoStr, operator) {
            return _this.compareDateStr(dateOneStr, dateTwoStr, exports.DATE_PATTERN_FROM_UI, operator);
        };
        this.isLessThanCurrentYear = function (year) {
            var currentYear = new Date().getFullYear();
            return year < currentYear;
        };
        this.sameDate = function (dateOne, dateTwo) { return _this.compareLocalDate(dateOne, dateTwo, '=='); };
        this.beforeDate = function (dateOne, dateTwo) { return _this.compareLocalDate(dateOne, dateTwo, '<'); };
        // beforeOrEqualsDate = (dateOne, dateTwo) => this.compareLocalDate(dateOne, dateTwo, '<=');
        this.beforeOrEqualsDate = publicInterface_1.beforeOrEqualsDate;
        this.afterDate = function (dateOne, dateTwo) { return _this.compareLocalDate(dateOne, dateTwo, '>'); };
        this.afterOrEqualsDate = function (dateOne, dateTwo) { return _this.compareLocalDate(dateOne, dateTwo, '>='); };
        this.isToday = function (date) { return _this.sameDate(date, _this.todayStr(exports.DATE_PATTERN_FROM_UI)); };
        this.beforeToday = function (date) { return _this.beforeDate(date, _this.todayStr(exports.DATE_PATTERN_FROM_UI)); };
        this.beforeOrEqualsToday = function (date) { return _this.beforeOrEqualsDate(date, _this.todayStr(exports.DATE_PATTERN_FROM_UI)); };
        this.afterToday = function (date) { return _this.afterDate(date, _this.todayStr(exports.DATE_PATTERN_FROM_UI)); };
        this.afterOrEqualsToday = function (date) { return _this.afterOrEqualsDate(date, _this.todayStr(exports.DATE_PATTERN_FROM_UI)); };
        this.sameDateStr = function (dateOneStr, dateTwoStr, pattern) { return _this.compareDateStr(dateOneStr, dateTwoStr, pattern, '=='); };
        this.beforeDateStr = function (dateOneStr, dateTwoStr, pattern) { return _this.compareDateStr(dateOneStr, dateTwoStr, pattern, '<'); };
        this.beforeOrEqualsDateStr = function (dateOneStr, dateTwoStr, pattern) {
            return _this.compareDateStr(dateOneStr, dateTwoStr, pattern, '<=');
        };
        this.afterDateStr = function (dateOneStr, dateTwoStr, pattern) { return _this.compareDateStr(dateOneStr, dateTwoStr, pattern, '>'); };
        this.afterOrEqualsDateStr = function (dateOneStr, dateTwoStr, pattern) {
            return _this.compareDateStr(dateOneStr, dateTwoStr, pattern, '>=');
        };
        this.sameDateStrPatterned = function (dateOneStr, dateTwoStr) {
            return _this.sameDateStr(dateOneStr, dateTwoStr, _this.DEFAULT_DATE_PATTERN);
        };
        this.beforeDateStrPatterned = function (dateOneStr, dateTwoStr) {
            return _this.beforeDateStr(dateOneStr, dateTwoStr, _this.DEFAULT_DATE_PATTERN);
        };
        this.beforeOrEqualsDateStrPatterned = function (dateOneStr, dateTwoStr) {
            return _this.beforeOrEqualsDateStr(dateOneStr, dateTwoStr, _this.DEFAULT_DATE_PATTERN);
        };
        this.afterDateStrPatterned = function (dateOneStr, dateTwoStr) {
            return _this.afterDateStr(dateOneStr, dateTwoStr, _this.DEFAULT_DATE_PATTERN);
        };
        this.afterOrEqualsDateStrPatterned = function (dateOneStr, dateTwoStr) {
            return _this.afterOrEqualsDateStr(dateOneStr, dateTwoStr, _this.DEFAULT_DATE_PATTERN);
        };
        this.todayStr = function (pattern) { return (pattern ? (0, moment_1.default)().format(pattern.toUpperCase()) : undefined); };
        this.isTodayStr = function (dateString, pattern) { return _this.sameDateStr(dateString, _this.todayStr(pattern), pattern); };
        this.beforeTodayStr = function (dateString, pattern) { return _this.beforeDateStr(dateString, _this.todayStr(pattern), pattern); };
        this.beforeOrEqualsTodayStr = function (dateString, pattern) {
            return _this.beforeOrEqualsDateStr(dateString, _this.todayStr(pattern), pattern);
        };
        this.afterTodayStr = function (dateString, pattern) { return _this.afterDateStr(dateString, _this.todayStr(pattern), pattern); };
        this.afterOrEqualsTodayStr = function (dateString, pattern) {
            return _this.afterOrEqualsDateStr(dateString, _this.todayStr(pattern), pattern);
        };
        this.isTodayStrPatterned = function (dateString) { return _this.isTodayStr(dateString, _this.DEFAULT_DATE_PATTERN); };
        this.beforeTodayStrPatterned = function (dateString) { return _this.beforeTodayStr(dateString, _this.DEFAULT_DATE_PATTERN); };
        this.beforeOrEqualsTodayStrPatterned = function (dateString) { return _this.beforeOrEqualsTodayStr(dateString, _this.DEFAULT_DATE_PATTERN); };
        this.afterTodayStrPatterned = function (dateString) { return _this.afterTodayStr(dateString, _this.DEFAULT_DATE_PATTERN); };
        this.afterOrEqualsTodayStrPatterned = function (dateString) { return _this.afterOrEqualsTodayStr(dateString, _this.DEFAULT_DATE_PATTERN); };
        this.monthsBetween = function (dateOneStr, dateTwoStr) {
            if (dateOneStr && dateTwoStr) {
                return (0, date_fns_1.differenceInMonths)(_this.parseDateStr(dateTwoStr).toDate(), _this.parseDateStr(dateOneStr).toDate());
            }
            return undefined;
        };
        this.yearsBetween = function (dateOneStr, dateTwoStr) {
            return dateOneStr && dateTwoStr
                ? (0, date_fns_1.differenceInYears)(_this.parseDateStr(dateTwoStr).toDate(), _this.parseDateStr(dateOneStr).toDate())
                : undefined;
        };
        this.DEFAULT_DATE_PATTERN = this.translateDateFormat(dateFormat);
    }
    return DateValidator;
}());
exports.DateValidator = DateValidator;
//# sourceMappingURL=DateValidator.js.map